import { Alert, Fade } from "@mui/material"
import { useState, useEffect } from "react";

/**
 * Sets alert visible for 2 seconds after message changes
 * and is not null
 */
export const AlertMessage = ({ severity, message }) => {

  const [alertVisibility, setAlertVisibility] = useState(false);
  
  useEffect(() => {
    setAlertVisibility(message != null);
  }, [message]);
  console.log(alertVisibility, message);

    return (
    <Fade
       in={alertVisibility} //Write the needed condition here to make it appear
       timeout={{ enter: 1000, exit: 1000 }} //Edit these two values to change the duration of transition when the element is getting appeared and disappeard
       addEndListener={() => {
         setTimeout(() => {
           setAlertVisibility(false);
           window.history.replaceState({state: {message: null}}, document.title);
         }, 2000);
       }}
       >
       <Alert sx={{ display: alertVisibility? 'flex':'none' }} severity={severity}>
        {message}
      </Alert>
    </Fade>
    );
}